import { LabelInValue } from "@/types";
import { Moment } from "moment";

export class LeasingDebtRecapReportFormHeaderState {
  lessor: LabelInValue | undefined = undefined;
  period: Moment | null = null;
}
